// vim: set ts=2 sts=2 sw=2 et:

import { connect } from "react-redux";

import { GlobalState } from "../../types/stateTypes";
import { PlatformRef } from "../types";
import JudgeView from "./JudgeView";
import { JudgePosition } from "./resolveJudgeVotes";

interface OwnProps {
  platformRef: PlatformRef | null;
  judgePosition: JudgePosition | null;
  locationPathname: string;
  locationSearch: string;
}

interface StateProps {
  lanHost: string | null;
}

export type JudgeContainerProps = OwnProps & StateProps;

// Judges connect from phones that have NO meet loaded, so the Judge UI must NOT gate on the local meet.
// A well-formed platformRef + Judge Position are the route requirements; lanHost is read only for the
// replacement-QR rewrite.
const mapStateToProps = (state: GlobalState): StateProps => {
  return {
    lanHost: state.wrpfLive.activeProfile?.lanHost || null,
  };
};

export default connect(mapStateToProps)(JudgeView);
